/** @format */

import OpenSpan from './OpenSpan';

export default OpenSpan;
